import { useEffect } from "react";
import { GetServerSideProps } from "next";

import { FullScreenPreloader } from "src/components/base/components/FullScreenPreloader";

import { constants } from "src/shared/constants";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

import type { TMLBBallparkUser } from "src/shared/types/globalStotre.types";

export default function DefaultTeamSchemaPage() {
  const router = useRouterExt();
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();

  useEffect(() => {
    router.pushSchema(TEAM_GLOBAL_SETTINGS?.DEFAULT_APP_ROUTE as string);
  }, []);

  return <FullScreenPreloader />;
}

export const getServerSideProps = (async (ctx) => {
  const { req } = ctx;
  // The MLB Ballpark headers / cookies are set centrally in _app.tsx for all routes.
  const { oktaId, email } = constants.mlbBallparkHeaders;
  const mlbBallparkOktaId =
    (req?.headers?.[oktaId] as string | null) ??
    (req?.cookies?.[oktaId] as string | null);
  const mlbBallparkEmail =
    (req?.headers?.[email] as string | null) ??
    (req?.cookies?.[email] as string | null);

  return {
    props: {
      mlbBallparkOktaId: mlbBallparkOktaId ?? null,
      mlbBallparkEmail: mlbBallparkEmail ?? null,
    },
  };
}) satisfies GetServerSideProps<TMLBBallparkUser>;
